import { render } from "./ProduçãoDiaria.vue?vue&type=template&id=aeaa18b2"
import script from "./ProduçãoDiaria.vue?vue&type=script&lang=js"
export * from "./ProduçãoDiaria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__